import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';
import { useAuthStore } from './features/auth/auth.store';

/**
 * The router context exposes the Zustand-backed auth status so route guards
 * can synchronously decide whether to redirect. The router holds a stable
 * reference to the context object; we update it in place when auth changes.
 */
export const router = createRouter({
  routeTree,
  context: {
    authStatus: useAuthStore.getState().authStatus,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
});

// Keep the router's context in sync with the store. `subscribe` returns the
// new state on each change; we patch context and let the router re-evaluate
// guards on the next navigation.
useAuthStore.subscribe((state) => {
  router.update({
    context: { ...router.options.context, authStatus: state.authStatus },
  });
  // When the user signs out, eagerly invalidate so any cached `_app` route
  // re-runs its `beforeLoad` guard and bounces them to `/sign-in`.
  if (state.authStatus === 'unauthenticated') {
    void router.invalidate();
  }
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
